import AuthDataFormSection from "./AuthDataFormSection";
import { automaticDataFields } from "../../forms/authFields";
import AuthDataFormSubSection from "./AuthDataFormSubSection";
import { useEffect, useState } from "react";
import Button from "../common/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { getStoredItem, setStoredItem } from "../../config/storageUtils";
import { useLanguage } from "../LanguageProvider/LanguageProvider";
import api from "../../api/ApiService";

const AutomaticDataForm = () => {
  const navigate = useNavigate();
  const automaticData = useLocation().state?.automaticData || {};
  const [formData, setFormData] = useState(automaticData);
  const { language, setLanguage } = useLanguage();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    getAutomaticData();
  }, []);

  const getAutomaticData = async () => {
    const resp = await api.get(`/automatic-data`);
    if (resp.status === 200) {
      setFormData(resp.data);
    }
  }

  const handleSubmit = async () => {
    navigate("/manual-data");
  };

  return (
    <>
      <AuthDataFormSection title={language ? "सीएएफ विवरण" : "CAF Details"}>
        {automaticDataFields.map((section, index) => (
          <AuthDataFormSubSection
            key={index}
            sectionHeading={language ? section.title.hi : section.title.en}
            sectionFields={section.fields}
            formData={formData}
            handleBlur={() => {}}
            handleChange={handleChange}
            language={language}
          />
        ))}
      </AuthDataFormSection>
      <div className="flex justify-end">
        <Button
          className="bg-btn font-semibold py-2 px-4 rounded-md"
          onClick={handleSubmit}
        >
          {language ? "अगला" : "Next"}
        </Button>
      </div>
    </>
  );
};

export default AutomaticDataForm;
